import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

function MetaRow({ label, value }) {
    if (value == null || value === '') return null;
    return (
        <>
            <dt>{label}</dt>
            <dd>{value}</dd>
        </>
    );
}

/**
 * Read-only IRL citation detail rail (AiWarden). Not a document viewer.
 */
const IrlCitationSidebar = ({ detail, onClose }) => {
    if (!detail) return null;

    const statusLabel =
        detail.status != null && detail.status !== '' ? String(detail.status) : detail.has_response === true ? 'Answered' : detail.has_response === false ? 'No response' : null;

    return (
        <div className={styles.aiWardenIrlSidebar}>
            <div className={styles.aiWardenPdfHeader}>
                <div className={styles.aiWardenPdfTitleWrap}>
                    <span className={styles.aiWardenKicker}>IRL citation</span>
                    <span className={styles.aiWardenPdfTitle} title={detail.irl_ref || 'IRL item'}>
                        {detail.irl_ref || 'Management response'}
                    </span>
                </div>
                <button type="button" className={styles.aiWardenPdfClose} onClick={onClose} aria-label="Close IRL citation panel">
                    <Dismiss20Regular />
                </button>
            </div>
            <div className={styles.aiWardenIrlSidebarBody}>
                {detail.question && (
                    <section className={styles.aiWardenIrlSection}>
                        <h3 className={styles.aiWardenInsightsHeadline}>Question</h3>
                        <p className={styles.aiWardenIrlText}>{detail.question}</p>
                    </section>
                )}

                {detail.answer && (
                    <section className={styles.aiWardenIrlSection}>
                        <h3 className={styles.aiWardenInsightsHeadline}>Answer</h3>
                        <p className={styles.aiWardenIrlText}>{detail.answer}</p>
                    </section>
                )}
            </div>
        </div>
    );
};

export default IrlCitationSidebar;
